export default __webpack_public_path__ + "static/blobs-dced546aa5280894b394df30819f1b6e.svg";